import { render, staticRenderFns } from "./DobInput.vue?vue&type=template&id=9fe46098&scoped=true&"
import script from "./DobInput.vue?vue&type=script&lang=js&"
export * from "./DobInput.vue?vue&type=script&lang=js&"
import style0 from "./DobInput.vue?vue&type=style&index=0&id=9fe46098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.registry.npmjs.org/vue-loader/15.9.8_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe46098",
  null
  
)

export default component.exports